"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuildStatusActor = exports.AI_ANALYSIS_RECOVERY_FINDINGS_RUN_ID_PREFIX = exports.FAST_MODE_ANALYSIS_RUN_ID_PREFIX = exports.AI_ANALYSIS_INCOMPLETE_REASON_PREFIX = exports.ANALYSIS_FAILED_STATUS_MESSAGE = exports.ANALYSIS_OFF_RAMP_REASON_PREFIX = exports.AnalysisDispatchClaimOutcome = exports.BuildEnrichmentArm = exports.BuildAutomationStep = exports.buildAutomationModeSchema = exports.BuildAutomationMode = void 0;
exports.isBuildAutomationMode = isBuildAutomationMode;
exports.isAutomationStepEnabled = isAutomationStepEnabled;
exports.isBuildStatusActor = isBuildStatusActor;
const z = require("zod");
var BuildAutomationMode;
(function (BuildAutomationMode) {
    BuildAutomationMode["Manual"] = "manual";
    BuildAutomationMode["Automatic"] = "automatic";
    BuildAutomationMode["Demoted"] = "demoted";
})(BuildAutomationMode || (exports.BuildAutomationMode = BuildAutomationMode = {}));
exports.buildAutomationModeSchema = z.nativeEnum(BuildAutomationMode);
function isBuildAutomationMode(value) {
    return Object.values(BuildAutomationMode).includes(value);
}
var BuildAutomationStep;
(function (BuildAutomationStep) {
    BuildAutomationStep["DispatchAnalysis"] = "dispatch_analysis";
    BuildAutomationStep["CompleteOnAnalysisSuccess"] = "complete_on_analysis_success";
    BuildAutomationStep["OffRampOnAnalysisFailure"] = "off_ramp_on_analysis_failure";
})(BuildAutomationStep || (exports.BuildAutomationStep = BuildAutomationStep = {}));
const AUTOMATED_STEPS_BY_MODE = {
    [BuildAutomationMode.Manual]: [],
    [BuildAutomationMode.Demoted]: [],
    [BuildAutomationMode.Automatic]: [
        BuildAutomationStep.DispatchAnalysis,
        BuildAutomationStep.CompleteOnAnalysisSuccess,
        BuildAutomationStep.OffRampOnAnalysisFailure,
    ],
};
function isAutomationStepEnabled(mode, step) {
    if (mode === undefined) {
        return false;
    }
    return AUTOMATED_STEPS_BY_MODE[mode].includes(step);
}
var BuildEnrichmentArm;
(function (BuildEnrichmentArm) {
    BuildEnrichmentArm["Ingestion"] = "ingestion";
    BuildEnrichmentArm["Merge"] = "merge";
})(BuildEnrichmentArm || (exports.BuildEnrichmentArm = BuildEnrichmentArm = {}));
var AnalysisDispatchClaimOutcome;
(function (AnalysisDispatchClaimOutcome) {
    AnalysisDispatchClaimOutcome["Claimed"] = "claimed";
    AnalysisDispatchClaimOutcome["AlreadyClaimed"] = "already_claimed";
    AnalysisDispatchClaimOutcome["NotEligible"] = "not_eligible";
})(AnalysisDispatchClaimOutcome || (exports.AnalysisDispatchClaimOutcome = AnalysisDispatchClaimOutcome = {}));
exports.ANALYSIS_OFF_RAMP_REASON_PREFIX = 'Automated analysis failed: ';
exports.ANALYSIS_FAILED_STATUS_MESSAGE = 'Analysis failed. Our team has been notified.';
exports.AI_ANALYSIS_INCOMPLETE_REASON_PREFIX = 'AI analysis incomplete';
exports.FAST_MODE_ANALYSIS_RUN_ID_PREFIX = 'fast-mode-';
exports.AI_ANALYSIS_RECOVERY_FINDINGS_RUN_ID_PREFIX = 'recovery-findings-';
var BuildStatusActor;
(function (BuildStatusActor) {
    BuildStatusActor["System"] = "system";
    BuildStatusActor["FastMode"] = "system:fast-mode";
    BuildStatusActor["CliResolveBomItems"] = "cli:resolve-bom-items";
    BuildStatusActor["CliAutomapSignals"] = "cli:automap-signals";
    BuildStatusActor["CliAutoreviewResolutions"] = "cli:autoreview-resolutions";
    BuildStatusActor["CliEnrolFastMode"] = "cli:enrol-fast-mode";
})(BuildStatusActor || (exports.BuildStatusActor = BuildStatusActor = {}));
function isBuildStatusActor(actor) {
    return Object.values(BuildStatusActor).includes(actor);
}
//# sourceMappingURL=build-automation.js.map